<template lang="pug">
	div(class="resume-wide resume-vertical-scroll")
		div(class="header-toolbar")
			b-button(class="btn-add" title="Add record" variant="outline-succes" style="border:none;" @click="m_addRecord")
				fa-icon(icon="plus")
			<b-button class="btn-copy" title="Copy and Paste" variant="outline-succes" style="border:none;"  @click="m_copyPaste">📝</b-button>
			b-button(class="btn-save" title="Save" variant="outline-success" style="border:none;" @click="m_save")
				fa-icon(icon="save")
			b-button(class="btn-delete" title="Delete current record" variant="outline-secondary" style="border:none;" @click="m_deleteRecord")
				fa-icon(icon="trash-alt")
			b-button(class="btn-cancel" title="Undo changes" variant="outline-warning" style="border:none;" @click="m_undo")
				fa-icon(icon="undo")
		div(class="form-group")
			kt-resume-education(
				ref="education"
				:value="d_resumeData.education"
				@input="d_resumeData.education = $event"
				@activate="d_activeSection = 'education'"
				:p_editMode="d_activeSection === 'education'"
			)
			kt-resume-certifications(
				ref="certifications"
				:value="d_resumeData.certifications"
				@input="d_resumeData.certifications = $event"
				@activate="d_activeSection = 'certifications'"
				:p_editMode="d_activeSection === 'certifications'"
			)
			kt-resume-positions(
				ref="positions"
				:value="d_resumeData.positions"
				@input="d_resumeData.positions = $event"
				@activate="d_activeSection = 'positions'"
				:p_editMode="d_activeSection === 'positions'"
			)
			
		<div style="width:60%; max-height:500px;overflow-y:auto">
			<strong class="primary">🏗️ Project Roles</strong>
			<b-table id="projectRoles" 	:items="d_projectRoles" :fields="d_projectRoleFields" sticky-header show-empty :empty-html="c_tableEmpty" small responsive head-variant="light">
				<template #cell(projectName)="data" >
					<div :title="data.item.projectName">
						<router-link :to="m_linkPath(data.item.projectNo)" > {{m_roleName(data.item.projectName)}}</router-link>
					</div>
				</template>
				<template #cell(startDate)="data" >
					<div >
						<span>{{m_formatDate(data.item.startDate)}}</span>
					</div>
				</template>
				<template #cell(endDate)="data" >
					<div>
						<span>{{m_formatDate(data.item.endDate)}}</span>
					</div>
				</template>				
			</b-table>
		</div>			
			
</template>			
<script>
import KTResumeEducation from "@/components/Ctrl/KT-ResumeEducation.vue";
import KTResumeCertifications from "@/components/Ctrl/KT-ResumeCertifications.vue";
import KTResumePositions from "@/components/Ctrl/KT-ResumePositions.vue";
import util,{fn_fmtMoney,kbdpAlert} from "@/utils/util.js";
export default {
  name: "resume",
  components: {
		'kt-resume-education': KTResumeEducation,
		'kt-resume-certifications': KTResumeCertifications,
		'kt-resume-positions': KTResumePositions,
	},
  inject: ["vcrec"],
  props: {
    value: Object,
    p_editMode: Boolean
  },

 data() {
    return {    
	d_resumeData: this.value?.resumeData || {
      education: [],
      certifications: [],
      positions: []
    },
	d_projectRoles:[],
    d_activeSection: null,
	d_projectRoleFields: [
				{ label: "Project Name", key: "projectName", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "Role", key: "roleName", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "Start Date", key: "startDate", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "End Date", key: "endDate", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				],
  }
},
 created() {},
 mounted() {},
 computed: {
	c_education(){return this.d_resumeData?.education;},
	c_certifications(){return this.d_resumeData?.certifications;},
	c_positions(){return this.d_resumeData?.positions;},
	c_tableEmpty() {return `<div style="color:#4fa4ff;text-align:left;">No Project Roles!!</div>`;
    },
 },
 watch: {
 value: {
  immediate: true,
  deep: true,
  handler(newVal) {
    if (!newVal) return
    this.d_resumeData = newVal.resumeData || {
      education: [],
      certifications: [],
      positions: []
     }
	this.d_projectRoles=newVal.projectRoles;
  }
}
},
methods: {
	m_addRecord(){
		this.$refs[this.d_activeSection]?.m_addRecord();
	},
	
	m_deleteRecord() {
		this.$refs[this.d_activeSection]?.m_deleteRecord();
	},
	m_copyPaste() {
		this.$refs[this.d_activeSection]?.m_copyPaste();
	},	

	m_undo(){
		this.$refs[this.d_activeSection]?.m_undo();
	},
	m_save() {
	
		this.$refs["education"].m_save();
		this.$refs["certifications"].m_save();
		this.$refs["positions"].m_save();
		const updatedValue = { ...this.value, resumeData: this.d_resumeData };
		this.$emit("input", updatedValue);
    },
   m_undoAll() {
      this.d_resumeData = {
        ...(this.value?.resumeData || {
          education: [],
          certifications: [],
          positions: []
        })
      }
    },
	m_linkPath(recNo) {
			return {path: util.fn_hrefVwRec('proj', recNo)};
	},
	m_roleName(name) {
		if(!name||name.length<20) return name;
		else return name.substring(0,19)+"...";
	},
	m_formatDate(date){
		return new Date(date).toLocaleDateString("en-US", {
			year: "numeric",
			month: "short",
			day: "numeric"
		});
	},
  }
  
}
</script>
<style scoped>
.cv-container {
  max-width: 900px;
  margin: auto;
}
section {
  margin-bottom: 2rem;
}
.section-header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.timeline {
  position: relative;
  list-style: none;
  padding-left: 30px;
  margin-top: 1rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ddd;
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  cursor: grab;
}

.dot {
  position: absolute;
  left: 4px;
  top: 18px;
  width: 16px;
  height: 16px;
  background: #2c7be5;
  border-radius: 50%;
}

.card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 1rem;
  margin-left: 20px;
}

input,
textarea {
  width: 100%;
  margin-bottom: 0.5rem;
}

.row {
  display: flex;
  gap: 0.5rem;
}

button {
  cursor: pointer;
}

.debug {
  background: #f7f7f7;
  padding: 1rem;
  font-size: 0.8rem;
}
.header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.header-btn .emoji {
  font-size: 1.2rem;
  cursor: pointer;
}
.emoji {
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.emoji:hover {
  background: #f0f0f0;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒";     /* "🡒" */
  color: #1E90FF; 
}
details[open] summary::before { 
  content:"🠣";  /* "🠣""🡑"*/ 
  color: #1E90FF; 
}
.btn-add {
	text-align: right;
	border:none;
	}
.btn-delete {
	color: #dc3545;
	text-align: right;
	border:none;
	}
.btn-add {
	color: #4fa4ff;
	border:none;
	}
.btn-expand {
	color: #FFA500;
	border:none;
	}
.resume-wide {
  width: 100%;
  min-width: 1200px; /* or whatever your tables need */
  position: relative;
  z-index: 10;
  overflow-x: auto;
  overflow-y: auto;
}
.col-4 {
  overflow: visible !important;
}
.resume-flex-expand {
  flex: 1 1 100%;
  max-width: 100%;
}
.resume-wide textarea {
  border: 1px solid #ccc;
  padding: 12px;
  font-size: 14px;
  line-height: 1.4;
}
.resume-vertical-scroll {
  max-height: 800px;   /* adjust to your needs */
  overflow-y: auto;
  overflow-x: hidden;  /* optional, keeps it tidy */
  border: none;
  border-radius: 4px;
  background: #fff;
}
.no-project-roles {
	color: #4fa4ff;
	text-align: left !important;
	font-size: 11px;
}

</style>
